module.exports = __webpack_public_path__ + "img/rouge-4.625a6cab.png";